/*
 * One place that knows how to reach the server.
 * Web: same origin, HttpOnly cookie. Android (Capacitor): absolute URL + Bearer token kept in native storage.
 */
import { Capacitor } from "@capacitor/core";

/**
 * True only inside the Android app. Not `"Capacitor" in window`: importing any Capacitor plugin defines that
 * global on the web too (chat 9 bug: web sign-in took the app's path and hung).
 */
export const isNative = Capacitor.isNativePlatform();

/** Set at build time for the Android app, e.g. VITE_API_BASE=https://engram.<you>.workers.dev */
export const API_BASE: string = isNative ? (import.meta.env.VITE_API_BASE ?? "") : "";

let token: string | undefined;
export function setToken(t: string | undefined) {
  token = t;
}
export function getToken() {
  return token;
}

export function apiFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const headers = new Headers(init.headers);
  headers.set("x-engram", "1");
  if (token) headers.set("authorization", `Bearer ${token}`);
  if (typeof init.body === "string" && !headers.has("content-type")) headers.set("content-type", "application/json");
  return fetch(`${API_BASE}/api${path}`, { ...init, headers, credentials: token ? "omit" : "same-origin" });
}
